/**
 * Performs a shallow comparison of two objects. It's "shallow" because we don't recurse into
 * values of the two operands to do further comparison
 *
 * @returns true if the two objects are the same by shallow comparison
 */
export default function shallowCompare<T extends object>(
  oldT: T | null | undefined,
  newT: T | null | undefined,
  ignoreProperties?: string[],
) {
  if (newT === null || newT === undefined || oldT === null || oldT === undefined) {
    return oldT === newT;
  }

  const oldPropNames = Object.getOwnPropertyNames(oldT);
  const newPropNames = Object.getOwnPropertyNames(newT);

  if (oldPropNames.length !== newPropNames.length) {
    return false;
  }

  for (const k of oldPropNames) {
    if (ignoreProperties && ignoreProperties.includes(k)) {
      continue;
    }
    if (oldT.hasOwnProperty(k) && (oldT as Record<string, any>)[k] !== (newT as Record<string, any>)[k]) {
      return false;
    }
  }

  return true;
}
